import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueGtag from "vue-gtag"; 
import { createAuth0 } from '@auth0/auth0-vue';

createApp(App)
    .use(router)
    .use(VueGtag, {
        config: { id: "G-7QZT9Q1WFR"}
    })
    .use(
        createAuth0({
            domain: "dev-w9poiwpf.eu.auth0.com",
            clientId: "M9IFsJDp2XMDcdT2CSE9RUANBidnptVu",
            authorizationParams: {
                redirect_uri: window.location.origin
            }
        })
    )
    .mount('#app')
